// extracted by mini-css-extract-plugin
export default {"container":"colorediconrectangle_container__D00wG"};